export const ENG_INIT = 'ENG_INIT';

export const ENG_RESET_WORK_AREA = 'ENG_RESET_WORK_AREA';
export const ENG_CLOSE_WORK_AREA = 'ENG_CLOSE_WORK_AREA';
export const ENG_OPEN_WORK_AREA = 'ENG_OPEN_WORK_AREA';
export const ENG_UPDATE_WORK_AREAS = 'ENG_UPDATE_WORK_AREAS';
export const ENG_CLEAR_WORK_AREAS = 'ENG_CLEAR_WORK_AREAS';

export const ENG_UPDATE_SKETCHER = 'ENG_UPDATE_SKETCHER';
export const ENG_UPDATE_SKETCHER_SUCCESS = 'ENG_UPDATE_SKETCHER_SUCCESS';
export const ENG_UPDATE_SKETCHER_FAILURE = 'ENG_UPDATE_SKETCHER_FAILURE';

export const ENG_SEND_WORK_AREA = 'ENG_SEND_WORK_AREA';
export const ENG_SEND_WORK_AREA_SUCCESS = 'ENG_SEND_WORK_AREA_SUCCESS';
export const ENG_SEND_WORK_AREA_FAILURE = 'ENG_SEND_WORK_AREA_FAILURE';

export const ENG_TOGGLE_GRAPHICS = 'ENG_TOGGLE_GRAPHICS';
export const ENG_TOGGLE_GRAPHICS_SUCCESS = 'ENG_TOGGLE_GRAPHICS_SUCCESS';
export const ENG_TOGGLE_GRAPHICS_FAILURE = 'ENG_TOGGLE_GRAPHICS_FAILURE';

export const ENG_CLEAR_GRAPHICS = 'ENG_CLEAR_GRAPHICS';
export const ENG_CLEAR_GRAPHICS_SUCCESS = 'ENG_CLEAR_GRAPHICS_SUCCESS';
export const ENG_CLEAR_GRAPHICS_FAILURE = 'ENG_CLEAR_GRAPHICS_FAILURE';

export const ENG_SET_GRAPHICS_STATUS = 'ENG_SET_GRAPHICS_STATUS';

export const ENG_MOVE_CHART = 'ENG_MOVE_CHART';
export const ENG_BUBBLE_CHART = 'ENG_BUBBLE_CHART';
export const ENG_RESIZE_CHART = 'ENG_RESIZE_CHART';
